export default __webpack_public_path__ + "static/media/logo_r2_logo_forLight.0df01ea9.png";